import {modify} from "mythil/object";
import identify from "~/identify";

const setStateValue = (model, modelPath, value) => {
    return modify(model, modelPath, (state) => {
        return {
            ...state,
            finished_at: Date.now(),
            status: identify.STATUS_SUCCESS,
            value: value
        };
    });
};

export default setStateValue;